import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
interface Props {
  data: CSection1;
}

const Section1: React.FC<Props> = ({ data }) => {
  return (
    <Container sx={{ py: 10 }}>
      <Grid container>
        <Grid item xs={12} md={8}>
          <Stack
            spacing={4}
            sx={{
              '&>p': { fontSize: { xs: 18, md: 24 } },
              px: { xs: 0, md: 10 },
            }}
          >
            <Typography color="text.secondary">{data?.subtitle}</Typography>
            <Typography
              color="text.primary"
              variant="h1"
              sx={{ typography: { xs: 'h2', md: 'h1' } }}
            >
              {data?.title}
            </Typography>
            <Typography color="text.secondary">{data?.description}</Typography>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              {data?.button1?.path && (
                <a href={data?.button1?.path} target="_blank" rel="noreferrer">
                  <Button
                    sx={{ px: 4, py: 3, borderRadius: 2 }}
                    endIcon={<ArrowForwardIcon />}
                    variant="contained"
                  >
                    {data?.button1?.label}
                  </Button>
                </a>
              )}
              {data?.button2?.path && (
                <a href={data?.button2?.path} target="_blank" rel="noreferrer">
                  <Button
                    endIcon={<ArrowForwardIcon />}
                    sx={{ px: 4, py: 3, borderRadius: 2 }}
                  >
                    {data?.button2?.label}
                  </Button>
                </a>
              )}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <Stack
            justifyContent="space-evenly"
            spacing={4}
            direction={{ xs: 'column', sm: 'row', md: 'column' }}
            sx={{
              height: 1,
              position: 'relative',
              p: 2,
              '&::before': {
                content: '""',
                width: 20,
                height: 20,
                borderTop: '2px solid white',
                borderRight: '2px solid white',
                position: 'absolute',
                top: 0,
                right: 0,
              },
              '&::after': {
                content: '""',
                width: 20,
                height: 20,
                borderBottom: '2px solid white',
                borderRight: '2px solid white',
                position: 'absolute',
                bottom: 0,
                right: 0,
              },
            }}
          >
            <Stack>
              <Typography
                color="text.primary"
                variant="h1"
                sx={{ fontSize: 'calc(24px + 6vw)' }}
              >
                {data?.count1?.title}
              </Typography>
              <Typography
                color="text.secondary"
                sx={{ fontSize: { xs: 18, md: 24 } }}
              >
                {data?.count1?.description}
              </Typography>
            </Stack>
            <Stack>
              <Typography
                color="text.primary"
                variant="h1"
                sx={{ fontSize: 'calc(24px + 6vw)' }}
              >
                {data?.count2?.title}
              </Typography>
              <Typography
                color="text.secondary"
                sx={{ fontSize: { xs: 18, md: 24 } }}
              >
                {data?.count2?.description}
              </Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Section1;
